import { spawn } from 'redux-saga/effects';

import stateDataSagas from './stateData/stateDataSagas';

export default function* sagas() {
	yield spawn(stateDataSagas);
}
